export default __webpack_public_path__ + "static/media/nf.a3f9585a.svg";